import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { silenceErrorAlert } from 'conversations-error-reporting/error-actions/builders/silenceErrorAlert';
import { FETCH_CHATFLOW_CONNECTION_STATUS } from '../constants/asyncActionTypes';
import { getChatflowConnectionStatus } from '../clients/getChatflowConnectionStatus';
export const fetchChatflowConnectionStatus = createAsyncAction({
  requestFn: getChatflowConnectionStatus,
  actionTypes: FETCH_CHATFLOW_CONNECTION_STATUS,
  toRecordFn: statusString => statusString,
  failureMetaActionCreator: silenceErrorAlert
});